import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteGenderMutationProps = {
	id: string | null
	onSettled: () => void
}

export const useDeleteGenderMutation = ({ id, onSettled }: UseDeleteGenderMutationProps) => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: deleteGenderMutation } = useMutation({
		mutationFn: () => {
			return axiosPrivate.delete(apiRoutes.gender(id!))
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Gender deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.genders.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteGenderMutation
	}
}
